import { render } from "./HeadingTitle.vue?vue&type=template&id=c7175494&scoped=true"
import script from "./HeadingTitle.vue?vue&type=script&lang=js"
export * from "./HeadingTitle.vue?vue&type=script&lang=js"

import "./HeadingTitle.vue?vue&type=style&index=0&id=c7175494&scoped=true&lang=css"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7175494"]])

export default __exports__